import React,{ useEffect, useState } from 'react';
import ProjectMap from './ProjectMap';
import Filters from './Filters';
import { FilterContext } from './Context';
import { APIProvider } from '@vis.gl/react-google-maps';

import axios from 'axios';

const GOOGLE_MAPS_API = 'AIzaSyCtSMkEcY2aOj445vlMBRNqDQhQoO_htYU';

const App = ({copy}) => {
    const [locations, setLocations] = useState([]);
    const [filteredLocations, setFilteredLocations] = useState([]);
    const [creditTypeFilter, setCreditTypeFilter] = useState('');
    const [projectTypeFilter, setProjectTypeFilter] = useState('');
    
    useEffect(() => {
        async function getLocations () {
            let res = await axios.get('/wp-json/atd/v1/projects');
            setLocations(res.data);
        }
        getLocations();
	}, []);

    useEffect(() => {
        setFilteredLocations(locations.filter((location) => {
            let include_credit = false;
            let include_project = false;

            if(!creditTypeFilter && !projectTypeFilter) {
                return true;
            }

            if(creditTypeFilter) {
                console.log(location);
                location.credit_types?.forEach((type) => {
                    if(type.slug === creditTypeFilter) {
                        include_credit = true;
                    }
                });
            }

            if(projectTypeFilter) {
                location.project_types?.forEach((type) => {
                    if(type.slug === projectTypeFilter) {
                        include_project = true;
                    }
                });
            }

            if(creditTypeFilter && projectTypeFilter) {
                return include_credit && include_project;
            }
            if(creditTypeFilter) {
                return include_credit;
            }

            if(projectTypeFilter) {
                return include_project;
            }

            return false;
        }));
	}, [locations, creditTypeFilter, projectTypeFilter]);

    return (
        <FilterContext.Provider value={{
            creditTypeFilter,
            setCreditTypeFilter,
            projectTypeFilter,
            setProjectTypeFilter,
        }}>
            <Filters />

            {copy ? (
                <div className="project-map-copy" dangerouslySetInnerHTML={{__html: copy}}></div>
            ) : null}
            
            <APIProvider apiKey={GOOGLE_MAPS_API}>
                <ProjectMap locations={filteredLocations} />
            </APIProvider>
        </FilterContext.Provider>
    )
}

export default App;